<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field
          slot="fp_billdate"
          :label="customLabel.fp_billdate || '申请日期'"
          v-model="form.main.fp_billdate"
        />
        <employee-field
          slot="fp_pleaseman"
          :label="customLabel.fp_pleaseman || '报销人'"
          v-model="form.main.fp_pleaseman"
          @select="onSelectPleaseman($event, form.main)"
        />
        <div class="weui-cell" slot="fp_department">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_department || "申请部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
           {{ form.main.fp_department}}
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="fp_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_type || "申请类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.fp_type"
              placeholder="请选择"
            >
              <option>个人</option>
              <option>部门</option>
              <option>公司</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="fp_receiver">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_receiver || "收款名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.fp_receiver"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="fp_bank">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_bank || "开户银行"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.fp_bank"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="fp_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_bankaccount || "银行账号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.fp_bankaccount"
              placeholder="请输入银行账号"
            />
          </div>
        </div>
        <currency-field
          slot="fp_currency"
          :label="customLabel.fp_currency || '币种'"
          v-model="form.main.fp_currency"
        />
        <div class="weui-cell" slot="fp_pleaseamount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_pleaseamount || "报销金额(元)"
            }}</label>
          </div>
          <div class="weui-cell__bd">
           {{ form.main.fp_pleaseamount }}
          </div>
        </div>
        <div class="weui-cell" v-if="form.main.fp_sourcetype" slot="fp_sourcetype">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_sourcetype || "来源类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
           {{ form.main.fp_sourcetype }}
          </div>
        </div>
        <div class="weui-cell" slot="fp_sourcecode" v-if="form.main.fp_sourcecode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.fp_sourcecode || "来源单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
           {{ form.main.fp_sourcecode }}
          </div>
        </div>
        <div class="weui-cell" slot="fp_content">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              :placeholder="customLabel.fp_content || '费用内容'"
              rows="3"
              v-model="form.main.fp_content"
              maxlength="80"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.fp_content ? form.main.fp_content.length : 0
              }}</span
              >/100
            </div>
          </div>
        </div>
        <custom-field 
          :label="customLabel.fp_text1 || '自定义字段1'"
          v-model="form.main.fp_text1" :caller="caller" fieldName="fp_text1"
          slot="fp_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.fp_text2 || '自定义字段2'"
          v-model="form.main.fp_text2" :caller="caller" fieldName="fp_text2"
          slot="fp_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.fp_text3 || '自定义字段3'"
          v-model="form.main.fp_text3" :caller="caller" fieldName="fp_text3"
          slot="fp_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.fp_text4 || '自定义字段4'"
          v-model="form.main.fp_text4" :caller="caller" fieldName="fp_text4"
          slot="fp_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.fp_text5 || '自定义字段5'"
          v-model="form.main.fp_text5" :caller="caller" fieldName="fp_text5"
          slot="fp_text5" hidden="true"
        />
      </custom-layout>
      <!-- 企业微信移动端选择电子发票 -->
      <div class="weui-cells" v-if="!isMiniProg && isWeixin">
        <a
          class="weui-cell weui-cell_access"
          href="javascript:"
          @click="selectWeixinInvoice"
        >
          <div class="weui-cell__bd">
            <p>电子发票</p>
          </div>
          <div class="weui-cell__ft">从微信卡包导入</div>
        </a>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items1"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>费用{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <fee-type-field
              :label="customLabel.fpd_itemname || '费用类型'"
              v-model="item.fpd_itemname"
              slot="fpd_itemname"
              @select="onSelectFeeType($event, item)"
            />
            <div class="weui-cell" slot="fpd_purpose">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fpd_purpose || "费用用途"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.fpd_purpose"
                  placeholder="请说明费用用途"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fpd_actualamount">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fpd_actualamount || "金额"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.fpd_actualamount"
                  placeholder="请填写实际金额"
                  minvalue="0.01"
                />
              </div>
            </div>
            <div class="weui-cell" slot="fpd_catename">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fpd_catename || "费用科目"
                }}</label>
              </div>
              <div class="weui-cell__bd">
               {{ item.fpd_catename }}
              </div>
            </div>
            <div class="weui-cell" slot="fpd_remark">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.fpd_remark || "备注"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.fpd_remark"
                  placeholder="备注"
                />
              </div>
            </div>
            <custom-field 
              :label="customLabel.fpd_text1 || '自定义字段1'"
              v-model="item.fpd_text1" :caller="caller" fieldName="fpd_text1"
              slot="fpd_text1" hidden="true"
            />
            <custom-field
              :label="customLabel.fpd_text2 || '自定义字段2'"
              v-model="item.fpd_text2" :caller="caller" fieldName="fpd_text2"
              slot="fpd_text2" hidden="true"
            />
            <custom-field 
              :label="customLabel.fpd_text3 || '自定义字段3'"
              v-model="item.fpd_text3" :caller="caller" fieldName="fpd_text3"
              slot="fpd_text3" hidden="true"
            />
            <custom-field 
              :label="customLabel.fpd_text4 || '自定义字段4'"
              v-model="item.fpd_text4" :caller="caller" fieldName="fpd_text4"
              slot="fpd_text4" hidden="true"
            />
            <custom-field 
              :label="customLabel.fpd_text5 || '自定义字段5'"
              v-model="item.fpd_text5" :caller="caller" fieldName="fpd_text5"
              slot="fpd_text5" hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items1.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div class="weui-cells">
        <file-field v-model="form.main.fp_attach" ref="fp_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import FeeTypeField from "@/components/field/FeeTypeField.vue";
import process from "@/mixins/process.js";
import weixin from "@/mixins/weixin.js";
import CustomField from "@/components/field/CustomField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";

export default {
  components: {
    CustomLayout,
    DateField,
    FileField,
    EmployeeField,
    FeeTypeField,
    CustomField,
    CurrencyField
  },
  mixins: [process, weixin],
  data() {
    return {
      baseUrl: "/api/oa/feeplease",
      codeField: "fp_code",
      statusField: "fp_statuscode",
      caller: "FeePlease",
      xtype: "oa-feeplease-formpanel",
      form: {
        main: {
          fp_billdate: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          fp_bank: null,
          fp_bankaccount: null,
          fp_content: null,
        },
        items1: [
          {
            fpd_itemname: null,
            fpd_purpose: null,
            fpd_actualamount: null,
            fpd_remark: null,
          },
        ],
      },
      isWeixin: false,
      isMiniProg: false,
    };
  },
  mounted() {
    var me = this,
      main = me.form.main;
    if (!main.id) {
      // 自动获取银行账号
      me.getCurrentUserInfo().then(function (info) {
        if (info) {
          main.fp_receiver = info.re_name;
          main.fp_bank = info.re_bank;
          main.fp_bankaccount = info.re_bankaccount;
        }
      });
      me.isWeixin = me.isWxWorkClient() || me.isWeixinClient();
    }
  },
  methods: {
    onWxEnabled() {
      var me = this;
      me.isMiniProgram().then(function (res) {
        me.isMiniProg = !!res;
      });
    },
    onSelectPleaseman(selected, main) {
      main.fp_pleasemancode = selected.em_code;
      main.fp_pleasemanid = selected.id;
      main.fp_department = selected.departmentDTO.dp_name;
      main.fp_departmentcode = selected.departmentDTO.dp_code;
      main.fp_departmentid = selected.departmentDTO.id;
    },
    save() {
      var me = this,
        main = me.form.main,
        items1 = me.form.items1,
        checked;
      if (!main.fp_bank) {
        me.$weui.topTips("请填写开户银行", 2000);
      } else if (!main.fp_currency) {
        me.$weui.topTips("请选择币种", 2000);
      }else if (!main.fp_type) {
        me.$weui.topTips("请选择申请类型", 2000);
      } else if (!main.fp_bankaccount) {
        me.$weui.topTips("请填写银行账号", 2000);
      } else if (!main.fp_content) {
        me.$weui.topTips("请填写费用内容", 2000);
      } else {
        var count = 0,
          amount = 0;
        items1.forEach(function (item) {
          if (!item.fpd_itemname) {
            me.$weui.topTips("请选择费用类型", 2000);
            return false;
          } else if (!item.fpd_purpose) {
            me.$weui.topTips("请填写费用用途", 2000);
            return false;
          } else if (!item.fpd_actualamount || item.fpd_actualamount < 0.01) {
            me.$weui.topTips("请填写实际金额", 2000);
            return false;
          } else {
            count++;
            item.fpd_detno = count;
            amount += item.fpd_actualamount;
          }
        });
        checked = count == items1.length;
        main.fp_pleaseamount = me.$number.round(amount, 2);
      }

      if (checked) {
        if (me.cardList) {
          me.p_save(function (res) {
            me.lockWeixinInvoice(res.data)
              .then(function () {
                me.p_router_to_read(res.data.id);
              })
              .catch(function () {
                me.p_router_to_read(res.data.id);
              });
          });
        } else {
          me.p_save();
        }
      }
    },
    removeItem(index) {
      var me = this,
        items1 = me.form.items1;
      if (items1.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items1.splice(index, 1);
      }
    },
    addItem() {
      var me = this,
        items1 = me.form.items1;
      items1.push({
        fpd_itemname: null,
        fpd_purpose: null,
        fpd_actualamount: null,
      });
    },
    getCurrentUserInfo() {
      var me = this;
      return me
        .$ajax({
          url: "/api/oa/receiver/current",
        })
        .then(function (res) {
          if (res.success && res.data) {
            return res.data;
          }
        });
    },
    onSelectFeeType(selection, item) {
      item.fpd_cateid = selection.fcs_cateid;
      item.fpd_catecode = selection.fcs_catecode;
      item.fpd_catename = selection.fcs_catename;
      item.fpd_itemname = selection.fcs_itemname;
      item.fpd_itemname = selection.fcs_itemname;
      item.fpd_islimit = selection.fcs_islimit;
      item.fpd_feetype = selection.fcs_biztype;
    },
    /**
     * 从微信卡包选择电子发票
     */
    selectWeixinInvoice() {
      var me = this,
        totalFee = 0,
        pdfList = [];
      me.chooseWxInvoice(function (result) {
        me.cardList = result[0];
        me.invoiceList = result[1];
        me.invoiceList.forEach((info) => {
          totalFee += info.user_info.fee / 100;
          pdfList.push(info.user_info.pdf_url);
        });
        me.$refs.attach.setThirdUrlList(pdfList);
        me.form.items1[0].fpd_actualamount = me.$number.round(totalFee, 2);
        // me.$weui.alert(JSON.stringify(result));
      });
    },
    /**
     * 报销单保存后，锁定电子发票状态
     */
    lockWeixinInvoice(doc) {
      var me = this,
        isWxWork = me.isWxWorkClient(),
        data = {
          openid: me.invoiceList[0].openid,
          use_type: doc.name,
          use_id: doc.id,
          invoice_list: me.cardList,
        };
      return me
        .$ajax({
          url: isWxWork ? "/api/qywx/invoice/lock" : "/api/weixin/invoice/lock",
          method: "POST",
          jsonData: data,
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          }
        });
    },
  },
};
</script>